import { useState, useEffect } from 'react'
import CustomSnakebar from "../../../../utils/CustomSnakebar";
import newRequest from "../../../../utils/newRequest";
import { useTranslation } from 'react-i18next';

const Addfootermenu = ({ isVisible, setVisibility, refreshBrandData }) =>
{
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
    const [category_name_en, setcategory_name_en] = useState("");
    const [category_name_ar, setcategory_name_ar] = useState("");
    const [Categorylevel, setCategorylevel] = useState('')
    const [Categoryleveldropdown, setCategoryleveldropdown] = useState([])
    const [Page, setPage] = useState('')
    const { t, i18n } = useTranslation();

    const [Pagedropdown, setPagedropdown] = useState([])
    const handleCloseCreatePopup = () =>
    {
        setVisibility(false);
    };

    useEffect(() =>
    {
        const getpagedata = async () =>
        {
            try {
                const response = await newRequest.get('/blogs/pages');
                const nameEnArray = response.data;
                setPagedropdown(nameEnArray);
            } catch (error) {
                // console.log(error);
            }
        };
        const getpagedatasdsd = async () =>
        {
            try {
                const response = await newRequest.get('/getAllmega_menu_categories');
                const nameEnArray = response.data;
                // console.log('getAllmega_menu_categories', nameEnArray);
                setCategoryleveldropdown(nameEnArray);
            } catch (error) {
                // console.log(error);
            }
        };
        getpagedatasdsd();
        getpagedata();
    }, []);

    const handleAddCompany = async () =>
    {
        try {
            const response = await newRequest.post('/creatfooter_menus/', {
                parent_id: Categorylevel,
                category_name_en: category_name_en,
                category_name_ar: category_name_ar,
                url: Page,
                status: 1,
            });

            setMessage(`${t('Footer menu')} ${category_name_en} ${t('has been added successfully')}.`);
            // console.log(response.data);
            refreshBrandData();
            handleCloseCreatePopup();

        } catch (error) {
            setError(error?.response?.data?.error || "Error");
        }


    };
 const resetSnakeBarMessages = () => {
   setError(null);
   setMessage(null);
 };

    return (
      <div>
        {message && (
          <CustomSnakebar
            message={message}
            severity="success"
            onClose={resetSnakeBarMessages}
          />
        )}
        {error && (
          <CustomSnakebar
            message={error}
            severity="error"
            onClose={resetSnakeBarMessages}
          />
        )}
        {/* create the post api popup */}
        {isVisible && (
          <div className="popup-overlay z-50">
            <div className="popup-container h-auto sm:w-[45%] w-full">
              <div
                className="popup-form w-full"
                style={{ maxHeight: "90vh", overflowY: "auto" }}
              >
                <form className="w-full">
                  <h2
                    className={`text-secondary font-sans font-semibold text-2xl ${
                      i18n.language === "ar" ? "text-end" : "text-start"
                    }`}
                  >
                    {t("Add")} {t("Footer menu")}{" "}
                  </h2>
                  <div className="flex flex-col sm:gap-3 gap-3 mt-5">
                    <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                      <label
                        htmlFor="field1"
                        className={`text-secondary  ${
                          i18n.language === "ar" ? "text-end" : "text-start"
                        }`}
                      >
                        {" "}
                        {t("Category")} {t("Name[English]")}
                      </label>
                      <input
                        type="text"
                        id="category_name_en"
                        value={category_name_en}
                        onChange={(e) => setcategory_name_en(e.target.value)}
                        placeholder={`${t("Enter")}${t("Category")}${t(
                          "Name[English]"
                        )}`}
                        className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                          i18n.language === "ar" ? "text-end" : "text-start"
                        }`}
                      />
                    </div>

                    <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                      <label
                        htmlFor="field1"
                        className={`text-secondary  ${
                          i18n.language === "ar" ? "text-end" : "text-start"
                        }`}
                      >
                        {t("Category")} {t("Name[Arabic]")}
                      </label>
                      <input
                        type="text"
                        id="category_name_ar"
                        value={category_name_ar}
                        onChange={(e) => setcategory_name_ar(e.target.value)}
                        placeholder={`${t("Enter")}${t("Category")}${t(
                          "Name[Arabic]"
                        )}`}
                        className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                          i18n.language === "ar" ? "text-end" : "text-start"
                        }`}
                      />
                    </div>

                    <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                      <label
                        htmlFor="status"
                        className={`text-secondary  ${
                          i18n.language === "ar" ? "text-end" : "text-start"
                        }`}
                      >
                        {t("Parent Category")}
                      </label>
                      <select
                        id="status"
                        value={Categorylevel}
                        onChange={(e) => setCategorylevel(e.target.value)}
                        className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                          i18n.language === "ar" ? "text-end" : "text-start"
                        }`}
                      >
                        <option value="Category Level">
                          {" "}
                          {t("Category Level")}
                        </option>
                        {Categoryleveldropdown &&
                          Categoryleveldropdown.map((itme, index) => {
                            return (
                              <option key={index} value={itme.id}>
                                {" "}
                                {i18n.language === "ar"
                                  ? itme?.category_name_ar
                                  : itme?.category_name_en}
                              </option>
                            );
                          })}
                      </select>
                    </div>

                    <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                      <label
                        htmlFor="status"
                        className={`text-secondary  ${
                          i18n.language === "ar" ? "text-end" : "text-start"
                        }`}
                      >
                        {t("Set Page")}
                      </label>
                      <select
                        id="status"
                        value={Page}
                        onChange={(e) => setPage(e.target.value)}
                        className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                          i18n.language === "ar" ? "text-end" : "text-start"
                        }`}
                      >
                        <option value="Select">-- {t("Select")} --</option>
                        {Pagedropdown &&
                          Pagedropdown.map((itme, index) => {
                            return (
                              <option key={index} value={itme.slug}>
                                {itme.name}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                  </div>

                  <div className="w-full flex justify-center items-center gap-8 mt-5">
                    <button
                      type="button"
                      className="px-5 py-2 w-[30%] rounded-sm bg-primary text-white font-body text-sm"
                      onClick={handleCloseCreatePopup}
                    >
                      {t("Close")}
                    </button>
                    <button
                      type="button"
                      onClick={handleAddCompany}
                      className="px-5 py-2 rounded-sm w-[70%] bg-secondary text-white font-body text-sm ml-2"
                    >
                      {t("Add")} {t("Footer menu")}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    );
}

export default Addfootermenu